module.exports = __webpack_public_path__ + "media/index_line.7ef173dd.mp3";